import { localize } from "@gtmhub/localization";

// used in timeline to display boolean metrics progress properly
export function booleanUpdateValue() {
  return function (newAttainmentValue: number) {
    const booleanText: string = newAttainmentValue === 1 ? "achieved" : "not_achieved_yet";

    return localize(booleanText);
  };
}
